import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const data = [
  { name: 'Red T-shirt', value: 400 },
  { name: 'Black Sneakers', value: 300 },
  { name: 'Denim Jeans', value: 300 },
];

const COLORS = ['#ff6f61', '#4caf50', '#2196f3'];

const TopSellingCard = () => {
  return (
    <Card
      sx={{
        height: '100%',
        backgroundColor: '#fff',
        border: '1px solid #ffecb3',
        borderRadius: 3,
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.05)',
        p: 2,
        transition: 'transform 0.3s ease',
        '&:hover': {
          transform: 'scale(1.02)',
          boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            mb: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <StarIcon sx={{ mr: 1 }} />
          Top Selling Products
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
          }}
        >
          {/* Product List */}
          <List dense sx={{ flex: 1 }}>
            {['Red T-shirt', 'Black Sneakers', 'Denim Jeans'].map(
              (product, index) => (
                <ListItem
                  key={product}
                  sx={{
                    pl: 0,
                    py: 0.5,
                    borderBottom: index < 2 ? '1px solid #ffecb3' : 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      bgcolor: COLORS[index],
                      borderRadius: '50%',
                      color: '#fff',
                      fontWeight: 'bold',
                      fontSize: '0.9rem',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      userSelect: 'none',
                    }}
                  >
                    {index + 1}
                  </Box>
                  <ListItemText
                    primary={product}
                    primaryTypographyProps={{ fontWeight: 600 }}
                  />
                </ListItem>
              )
            )}
          </List>

          {/* Responsive Pie Chart */}
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              // height: '100%' removed for flexibility
            }}
          >
            <Box
              sx={{
                width: '100%',
                maxWidth: 300,
                aspectRatio: '1 / 1', // ensures square layout
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={data}
                    innerRadius="50%"
                    outerRadius="70%"
                    paddingAngle={5}
                    dataKey="value"
                    stroke="none"
                  >
                    {data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Legend
                    verticalAlign="bottom"
                    height={36}
                    wrapperStyle={{ fontSize: '12px', paddingTop: '8px' }}
                  />
                </PieChart>
              </ResponsiveContainer>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TopSellingCard;
